<template>
    <div class="wtw-container column-list-container clearfix">
        <div class="option button full-width outline"
             v-for="option in options"
             @click.stop="toggleOption(option.product_option_value_id)"
             :class="{active: optionActive(option.product_option_value_id)}"
        >
            {{ option.product_option_value_title }}
        </div>
    </div>
</template>

<script>


    export default{
        data() {
            return {
                optionValues: [],
                canGoToNextStep: true
            }
        },
        props:['options', 'sendOptions', 'optionsAll', 'optionsSelected'],
        created(){
            if(this.optionsSelected) {
                this.optionValues = this.optionsSelected;
            }
        },
        methods:{
            toggleOption(optionValue){
                let index = this.optionIndex(optionValue);
                if(index !== -1){
                    this.optionValues.splice(index, 1);
                } else {
                    this.optionValues.push(optionValue);
                }
            },
            optionIndex(optionValue){
                return this.optionValues.indexOf(optionValue);
            },
            optionActive(optionValue){
                return this.optionIndex(optionValue) !== -1;
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    let optionIds = this.options.map((option) => {
                        return option.product_option_value_id;
                    });
                    if(this.$parent.getNoSkip) {
                        let found = optionIds.some(r=> this.optionValues.indexOf(r) >= 0)
                        this.canGoToNextStep = found ? true : false
                    } else {
                        this.canGoToNextStep = true
                    }
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds)
                    this.$parent.$emit('optionsSending', this.optionValues, this.canGoToNextStep);
                }
            }
        }
    }
</script>